<template>
  <v-container>
    <site-creation-dialog
      v-model="siteDialog"
      :site="selectedSite"
      v-on:validate-edit-site="editSite($event)"
      v-on:validate-create-site="createSite($event)"
    />
    <v-row>
      <v-col>
        <v-row justify="space-between">
          <v-col lg="4" sm="8">
            <h1 class="display-1 font-weight-light">
              {{ $t("Manage_Sites.Sites") }}
            </h1>
          </v-col>
          <v-col lg="2" align="right">
            <v-btn
              outlined
              color="green"
              v-on:click="
                selectedSite = undefined;
                siteDialog = true;
              "
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t("Generic.Add") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              :label="$t('Generic.Search')"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :loading="sitesLoading"
              :headers="headers"
              :items="sites"
              :search="search"
              :items-per-page="rowsPerPage"
              :no-data-text="$t('Generic.No_Data')"
              :no-results-text="$t('Generic.No_Data_Search')"
              class="elevation-1"
              :footer-props="{
                itemsPerPageText: $t('Generic.Rows_per_page')
              }"
            >
              <template v-slot:item.Actions="{ item }">
                <v-btn small text icon color="blue" class="ma-0 pa-0">
                  <v-icon
                    small
                    class="ma-0 pa-0"
                    v-on:click="
                      selectedSite = item;
                      siteDialog = true;
                    "
                    >mdi-pencil</v-icon
                  >
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SiteService from "@/services/SiteService";
import SiteCreationDialog from "@/components/ManageSites/SiteCreationDialog";

export default {
  data() {
    return {
      search: "",
      sitesLoading: true,
      selectedSite: undefined,
      siteDialog: false,
      rowsPerPage: 10,
      sites: [],
      headers: [
        {
          text: this.$i18n.t("Generic.Name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$i18n.t("Generic.Actions"),
          value: "Actions",
          align: "right",
          sortable: false
        }
      ]
    };
  },
  methods: {
    editSite(editedSite) {
      SiteService.UpdateSite(editedSite)
        .then(() => {
          this.siteDialog = false;
          Object.assign(this.selectedSite, editedSite);
          this.$emit("show-success", this.$i18n.t("Success.Site_Edited"));
        })
        .catch(() =>
          this.$emit("show-error", this.$i18n.t("Error.Site_Edition_Failed"))
        );
    },
    createSite(newSite) {
      SiteService.CreateSite(newSite)
        .then(response => {
          this.siteDialog = false;
          this.sites.push(response.data);
          this.$emit("show-success", this.$i18n.t("Success.Site_Created"));
        })
        .catch(error =>
          this.$emit("show-error", this.$i18n.t("Error.Site_Creation_Failed"))
        );
    }
  },
  components: {
    SiteCreationDialog
  },
  mounted() {
    SiteService.GetAllSites()
      .then(response => (this.sites = response.data))
      .catch(error =>
        this.$emit("show-error", this.$i18n.t("Error.Sites_Not_Retrieved"))
      )
      .finally(() => (this.sitesLoading = false));
  }
};
</script>
